import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { ListingLink } from '..';
import { EditListingOnboardingCallForm } from '../../forms';
import { ensureOwnListing } from '../../util/data';
import { FormattedMessage } from '../../util/reactIntl';
import { types as sdkTypes } from '../../util/sdkLoader';
import { LISTING_STATE_DRAFT } from '../../util/types';
import { parse } from '../../util/urlHelpers';
import css from './EditListingOnboardingCallPanel.css';


const { Money } = sdkTypes;

const EditListingOnboardingCallPanel = props => {
  const {
    className,
    rootClassName,
    listing,
    disabled,
    ready,
    onSubmit,
    onChange,
    onChangeInstantBooking,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
    currentUser,
    submitButtonId,
  } = props;
  const location = useLocation();
  const { search } = location;
  const { shouldSubmit } = parse(search);
  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureOwnListing(listing);

  const userPublicData = currentUser.attributes.profile && currentUser.attributes.profile.publicData || {};

  const { isOnboardingCallScheduled } = userPublicData;

  const { publicData} = currentListing.attributes;
  const {isListingOnboardingCallScheduled = false} = publicData;

  const isPublished = currentListing.id && currentListing.attributes.state !== LISTING_STATE_DRAFT;
  const panelTitle = isPublished ? (
    <FormattedMessage
      id="EditListingOnboardingCallPanel.title"
      values={{ listingTitle: <ListingLink listing={listing} /> }}
    />
  ) : (
    <FormattedMessage id="EditListingOnboardingCallPanel.createListingTitle" />
  );

  const form = (
    <EditListingOnboardingCallForm
      currentUser={currentUser}
      isOnboardingCallScheduled={isOnboardingCallScheduled}
      isListingOnboardingCallScheduled={isListingOnboardingCallScheduled}
      listing={listing}
      shouldSubmit={shouldSubmit}
      className={css.form}
      initialValues={{ isListingOnboardingCallScheduled }}
      onSubmit={values => {
          if(values.isListingOnboardingCallScheduled) {
            onSubmit({});
          }
          else {
            onSubmit({
              publicData: {
                isListingOnboardingCallScheduled: true
              }
            });
          }
      }}
      onChangeInstantBooking={onChangeInstantBooking}
      onChange={onChange}
      saveActionMsg={submitButtonText}
      disabled={disabled}
      ready={ready}
      updated={panelUpdated}
      updateInProgress={updateInProgress}
      fetchErrors={errors}
      submitButtonId={submitButtonId}
    />
  );

  return (
    <div className={classes}>
      <h1 className={css.title}>{panelTitle}</h1>
      {form}
    </div>
  );
};

const { func, object, string, bool } = PropTypes;

EditListingOnboardingCallPanel.defaultProps = {
  className: null,
  rootClassName: null,
  listing: null,
};

EditListingOnboardingCallPanel.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  isNewListingFlow: bool.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
  submitButtonId: string,
  onChangeInstantBooking: func,
};

export default EditListingOnboardingCallPanel;
